module.exports = __webpack_public_path__ + "img/dravidians-DE.79a629da.png";